import { render, staticRenderFns } from "./NewsCardsHome.vue?vue&type=template&id=5f4cff38&scoped=true&"
import script from "./NewsCardsHome.vue?vue&type=script&lang=js&"
export * from "./NewsCardsHome.vue?vue&type=script&lang=js&"
import style0 from "./NewsCardsHome.vue?vue&type=style&index=0&id=5f4cff38&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4cff38",
  null
  
)

export default component.exports